import React from 'react';
import styles from './suggest-knowledge-widget.module.scss';
import { ROUTES, EVENTS } from 'shared/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleArrowRight } from '@fortawesome/pro-solid-svg-icons';
import analyticsService from 'src/helpers/analytics.service';
import { Link } from 'react-router-dom';

const SuggestKnowledgeItemWidgetComponent = ({ lang }) => {
  const onClick = () => {
    analyticsService.track(EVENTS.SUGGEST_CONTENT.START);
  };

  return (
    <div className={styles.root}>
      <h2 className={styles.title}>{lang.TITLE}</h2>
      <div className={styles.container}>
        <p className={styles.description}>{lang.DESCRIPTION}</p>
        <hr />
        <Link to={ROUTES.SUGGEST_CONTENT} className={styles.button} onClick={onClick}>
          <p className={styles.buttonLabel}>{lang.BUTTON}</p>
          <FontAwesomeIcon icon={faCircleArrowRight} className={styles.icon} />
        </Link>
      </div>
    </div>
  );
};

export { SuggestKnowledgeItemWidgetComponent };
